import { notify } from 'utils/reduxUtils';

import * as actionTypes from '../types';

export const copyQuote = {
  request: (payload: { quoteId: number; openInNewTab?: boolean }) => ({
    type: actionTypes.QUOTE_COPY_REQUEST,
    payload,
  }),
  success: () => ({
    type: actionTypes.QUOTE_COPY_SUCCESS,
  }),
  error: notify(
    (payload: { error: unknown }) => ({
      type: actionTypes.QUOTE_COPY_ERROR,
      payload,
    }),
    "Couldn't copy quote",
  ),
};
